module.exports = __webpack_public_path__ + "84b90d3fa19bf86bd15082f6a74ddb2f.svg";